import { Injectable } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { SharedChatNotifier } from '../notifiers/shared-chat-notifier';
import { ChatState } from '../states/chat-state';

@Injectable()
export class SharedChatProvider extends BaseProvider<SharedChatNotifier, ChatState> {
  constructor() {
    super(SharedChatNotifier);
  }
}
